import React from "react";

/**
 * Funil do anúncio ao pedido. As três primeiras etapas vêm da Meta (viram,
 * clicaram, chegaram no cardápio); as três últimas são do cardápio do Núcleo
 * (sacola, pagamento, pedido), por campanha desde 04/10/2026.
 */
export default function Funil({ etapas, titulo = "Do anúncio ao pedido" }) {
  const maximo = Math.max(1, ...(etapas || []).map((e) => e.valor));
  const temNucleo = (etapas || []).some((e) => e.fonte === "nucleo" && e.valor > 0);
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="funil-meta">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <h3 className="font-semibold">{titulo}</h3>
        <div className="flex items-center gap-3 text-[11px] text-muted-foreground">
          <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm bg-sky-500" />segundo a Meta</span>
          <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm bg-emerald-500" />no cardápio</span>
        </div>
      </div>
      <div className="space-y-1.5">
        {(etapas || []).map((e, i) => {
          const anterior = i > 0 ? etapas[i - 1].valor : null;
          const taxa = anterior ? Math.round((e.valor / anterior) * 100) : null;
          return (
            <div key={e.etapa} className="flex items-center gap-2 text-sm">
              <span className="w-40 shrink-0 text-xs sm:text-sm">{e.etapa}</span>
              <div className="flex-1 h-5 rounded bg-muted/40 overflow-hidden">
                <div className={`h-full rounded ${e.fonte === "meta" ? "bg-sky-500" : "bg-emerald-500"}`} style={{ width: `${(e.valor / maximo) * 100}%`, minWidth: e.valor ? 3 : 0 }} />
              </div>
              <span className="w-24 text-right tabular-nums font-semibold">{e.valor.toLocaleString("pt-BR")}</span>
              <span className="w-12 text-right text-[11px] text-muted-foreground tabular-nums">{taxa == null ? "" : `${taxa}%`}</span>
            </div>
          );
        })}
      </div>
      {!temNucleo && (
        <p className="text-[11px] text-muted-foreground mt-2">
          As etapas do cardápio por campanha só existem para cliques que chegaram com os parâmetros do anúncio (desde 04/10/2026).
        </p>
      )}
    </section>
  );
}
